import LongText from '../Elements/LongText';
import React from 'react';
import urlHelper from '../Helpers/urlHelper';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import FaIcon from '../Elements/FaIcon';

export default class ClientPrePaymentItem {
  constructor(item) {
    if (item) {
      this.ClDesc = item.clDesc;
      this.ClCiid = item.clCiid;
      this.CiInvoiceNumber = item.ciInvoiceNumber;
      this.CiInternalReferenceNumber = item.ciInternalReferenceNumber;
      this.ClLliname = item.clLliname;
      this.ClPaidStatus = item.clPaidStatus;
      this.ClPaid = item.clPaid;
      this.ClCredit = item.clCredit;
      this.ClId = item.clId;
      this.ClCircysymbol = item.clCircysymbol;
      this.ClCircycode = item.clCircycode;
      this.ClTotal = item.clTotal;
      this.ClCfDisplayName = item.clCfDisplayName;
      this.ClServiceDisplayName = item.clServiceDisplayName;
      this.ClOpportunityDisplayName = item.clOpportunityDisplayName;
      this.ClInitialDue = item.clInitialDue;
      this.ClTax = item.clTax;
      this.ClCurrent = item.clCurrent;
      this.ClCfid = item.clCfid;
      this.CiCcid = item.ciCcid;
      this.CiCcname = item.ciCcname;
      return;
    }
    this.ClDesc = '';
    this.ClCiid = '';
    this.CiInvoiceNumber = '';
    this.CiInternalReferenceNumber = '';
    this.ClLliname = '';
    this.ClPaidStatus = '';
    this.ClPaid = '';
    this.ClCredit = '';
    this.ClId = '';
    this.ClCircysymbol = '';
    this.ClCircycode = '';
    this.ClTotal = '';
    this.ClCfDisplayName = '';
    this.ClServiceDisplayName = '';
    this.ClOpportunityDisplayName = '';
    this.ClInitialDue = '';
    this.ClTax = '';
    this.ClCurrent = '';
    this.ClCfid = '';
    this.CiCcid = '';
    this.CiCcname = '';
  }

  static MoneyFields = ['ClPaid', 'ClCredit', 'ClTotal', 'ClInitialDue', 'ClTax', 'ClCurrent'];
  static MoneyFieldsSecondary = ['ClPaid', 'ClCredit', 'ClTotal', 'ClInitialDue', 'ClTax', 'ClCurrent'];

  static Currency() {
    return 'ClCircycode';
  }

  static CurrencySecondary() {
    return 'ClCircycode';
  }

  static DateFields = [];

  static nameOfTheItemDetailList() {
    return 'Client Prepayment';
  }

  static FieldsToShowInListTable = [
    {
      data: [
        { name: '-message-', label: 'General Information', className: 'text-left' },
        { label: 'BARE Invoice #', name: 'ClCiid', className: 'text-left' },
        { label: 'Client Fee', name: 'ClTotal', className: 'text-left' },
        { label: 'Type', name: 'ClLliname', className: 'text-left' },
        { label: 'Client', name: 'CiCcname', className: 'text-left' },
        {
          label: 'Project',
          name: (item) => ClientPrePaymentItem.getProjectContentLink(item),
          className: 'text-left',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          label: 'Description',
          name: 'ClDesc',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
          contentHasHtml: true,
        },
        { label: 'Initial Total', name: 'ClInitialDue', className: 'text-left' },
        { label: 'Paid', name: 'ClPaid', className: 'text-left' },
        { label: 'Current Due', name: 'ClCurrent', className: 'text-left' },
        { label: 'Credit', name: 'ClCredit', className: 'text-left' },
        { label: 'Tax', name: 'ClTax', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Line Item ID', orderById: 'ClId', data: ClientPrePaymentItem.GetDetailCellContent, minWidth: 20 },
      { label: 'Client', orderById: 'CiCcname', data: ClientPrePaymentItem.getCiCcnameCellContent, minWidth: 40 },
      { label: 'Name', orderById: 'ClDesc', data: ClientPrePaymentItem.getClDescCellContent, minWidth: 40 },
      {
        label: 'Bare Invoice #',
        orderById: 'ClCiid',
        data: 'ClCiid',
        minWidth: 20,
      },
      {
        label: 'Client Invoice #',
        orderById: 'CiInvoiceNumber',
        data: ClientPrePaymentItem.getCiInvoiceNumberCellContent,
        minWidth: 40,
      },
      {
        label: 'Internal Reference #',
        orderById: 'CiInternalReferenceNumber',
        data: ClientPrePaymentItem.getInternalReferenceCellContent,
        minWidth: 40,
      },
      { label: 'Type', orderById: 'ClLliname', data: 'ClLliname', minWidth: 20 },
      { label: 'Paid', orderById: 'ClPaidStatus', data: 'ClPaidStatus', minWidth: 20 },
      { label: 'Paid Amount', orderById: 'ClPaid', data: 'ClPaid', minWidth: 20 },
      {
        label: 'Outstanding',
        orderById: 'ClCurrent',
        data: 'ClCurrent',
        minWidth: 20,
      },
    ];
  }

  static getClDescCellContent(item) {
    return (
      <LongText
        text={item.ClDesc ? item.ClDesc : ' '}
        maxLength={100}
      />
    );
  }

  static getCiInvoiceNumberCellContent(item) {
    return (
      <LongText
        text={item.CiInvoiceNumber ? item.CiInvoiceNumber : ' '}
        maxLength={60}
      />
    );
  }

  static getInternalReferenceCellContent(item) {
    return (
      <LongText
        text={item.CiInternalReferenceNumber ? item.CiInternalReferenceNumber : ' '}
        maxLength={60}
      />
    );
  }

  static getCiCcnameCellContent(item) {
    return (
      <LongText
        text={item.CiCcname ? item.CiCcname : ' '}
        maxLength={30}
      />
    );
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ClId,
      '',
      '',
      'clientprepaymentdetails',
      `id=${item.ClId}`,
      'Open up in a new tab'
    );
  }

  static getProjectContentLink(item) {
    return (
      <div className='row'>
        <div className='col-9 text-left'>{item.ClCfDisplayName}</div>
        <div
          className='col-3 text-left link p-0 border-0'
          onClick={() => ClientPrePaymentItem.clickOnProjectChangeLink(item)}
        >
          <FaIcon iconName='fa-solid fa-edit' /> Change Project
        </div>
      </div>
    );
  }

  static clickOnProjectChangeLink(item) {
    alert('Empty function');
  }
}
